<template>
  <v-container>
    <!-- 상단 검색 줄 -->
    <div>
      <v-row
        align="center"
        dense
      >
        <v-col
          cols="5"
          sm="5"
        >
          <v-menu
            v-model="startDatePickerMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="inputStartDate"
                class="date-picker"
                label="시작일자"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <v-date-picker
              v-model="inputStartDate"
              :first-day-of-week="0"
              locale="ko"
              year-icon="mdi-calendar-blank"
              :day-format="date => parseInt(date.substr(8, 2))"
              no-title
              scrollable
              @input="startDatePickerMenu = false"
            />
          </v-menu>
        </v-col>
        <v-col
          cols="5"
          sm="5"
        >
          <v-menu
            v-model="endDatePickerMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="inputEditDate"
                class="date-picker"
                label="종료일자"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <v-date-picker
              v-model="inputEditDate"
              :first-day-of-week="0"
              locale="ko"
              year-icon="mdi-calendar-blank"
              :day-format="date => parseInt(date.substr(8, 2))"
              no-title
              scrollable
              @input="endDatePickerMenu = false"
            />
          </v-menu>
        </v-col>
        <v-col
          class="align-a-center"
          align-self="center"
          cols="2"
          sm="2"
        >
          <v-btn
            small
            height="30px"
            @click="getRequestList"
          >
            조회
          </v-btn>
        </v-col>
        <v-col
          cols="12"
          sm="12"
        >
          <v-select
            v-model="selectedClient"
            :items="client"
            value="id"
            multiple
            label="거래처"
            single-line
            clearable
          />
        </v-col>
      </v-row>
    </div>

    <!-- 테이블 -->
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="filterItems"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      :page.sync="page"
      :options.sync="options"
      :items-per-page="itemsPerPage"
      show-select
      no-data-text="조회 결과 없음"
      hide-default-footer
      item-key="id"
      show-expand
      class="elevation-1"
      @page-count="pageCount = $event"
    >
      <template v-slot:top>
        <v-toolbar
          flat
        >
          <v-container>
            <v-select
              v-model="stateFilter"
              :items="states"
              label="진행상태"
              small-chips
              clearable
              single-line
              multiple
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{ item }}</span>
                </v-chip>
                <span
                  v-if="index === 1"
                  class="grey--text text-caption"
                >
                  (+{{ stateFilter.length - 1 }} others)
                </span>
              </template>
            </v-select>
          </v-container>
          <v-divider
            dark
          />
          <v-spacer />
          <v-dialog
            v-model="dialogChangeState"
            max-width="300"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-show="isMultiSelect"
                color="blue darken-2"
                dark
                class="mb-2"
                small
                v-bind="attrs"
                v-on="on"
              >
                상태변경
              </v-btn>
            </template>
            <v-card>
              <v-card-title />
              <v-combobox
                v-model="selectedState"
                :items="states"
                label="상태"
                single-line
              />
              <v-card-actions>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="dialogChangeState = false"
                >
                  취소
                </v-btn>
                <v-spacer />
                <v-btn
                  color="blue darken-1"
                  text
                  @click="changeState"
                >
                  저장
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog
            v-model="dialog"
            max-width="400px"
          >
            <v-card>
              <v-system-bar
                color="pink darken-2"
                dark
              >
                <v-spacer />
                <v-icon
                  @click="dialog = !dialog"
                >
                  mdi-close
                </v-icon>
              </v-system-bar>
              <v-container
                class="my-container"
              >
                <v-menu
                  v-model="DatePickerMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="editedItem.requestDate"
                      label="의뢰일자"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-show="editableInfo"
                    v-model="editedItem.requestDate"
                    :allowed-dates="disablePastDates"
                    :first-day-of-week="0"
                    locale="ko"
                    year-icon="mdi-calendar-blank"
                    :day-format="date => parseInt(date.substr(8, 2))"
                    no-title
                    scrollable
                    @input="DatePickerMenu = false"
                  />
                </v-menu>
                <v-row>
                  <v-col>
                    <v-select
                      v-model="editedItem.requestState"
                      :items="states"
                      dense
                      hide-selected
                    >
                      <template v-slot:selection="{item}">
                        <v-chip
                          :color="getColor(item)"
                          small
                          outlined
                        >
                          {{ item }}
                        </v-chip>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col>
                    <v-btn
                      color="blue darken-1"
                      small
                      text
                      @click="getLogStates"
                    >
                      <v-icon>
                        mdi-file-clock-outline
                      </v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-btn
                  v-show="editableInfo"
                  depressed
                  small
                  @click="addSample"
                >
                  검체 추가

                  <v-icon
                    right
                  >
                    mdi-plus
                  </v-icon>
                </v-btn>
                <v-list>
                  <v-list-item
                    v-for="(chat, j) in editedItem.samples"
                    :key="j"
                    dense
                  >
                    <v-list-item-content>
                      <v-list-item-title v-html="chat.initialName" />
                      <v-list-item-subtitle v-html="chat.sampleNum" />
                    </v-list-item-content>
                    <v-list-item-icon>
                      <v-icon
                        v-show="editableInfo"
                        @click="editedSample(j)"
                      >
                        mdi-pencil
                      </v-icon>
                      <v-icon
                        v-show="editableInfo"
                        @click="deleteSample"
                      >
                        mdi-delete
                      </v-icon>
                    </v-list-item-icon>
                  </v-list-item>
                </v-list>
                <v-divider />
                <v-row align="center">
                  <v-col cols="6">
                    <number-spinner
                      v-model="editedItem.spEdta"
                      label="EDTA"
                      :edited="editableInfo"
                    />
                  </v-col>
                  <v-col cols="6">
                    <number-spinner
                      v-model="editedItem.spSerum"
                      label="Serum"
                      :edited="editableInfo"
                    />
                  </v-col>
                  <v-col cols="6">
                    <number-spinner
                      v-model="editedItem.spUrine"
                      label="Urine"
                      :edited="editableInfo"
                    />
                  </v-col>
                  <v-col cols="6">
                    <number-spinner
                      v-model="editedItem.spEtc"
                      label="기타"
                      :edited="editableInfo"
                    />
                  </v-col>
                </v-row>
                <v-divider />
                <v-textarea
                  v-model="editedItem.memo"
                  :readonly="!editableInfo"
                  auto-grow
                  label="비고"
                  rows="2"
                  filled
                />
              </v-container>
              <v-card-actions>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="dialogDelete = !dialogDelete"
                >
                  삭제
                </v-btn>
                <v-spacer />
                <v-btn
                  color="blue darken-1"
                  text
                  @click="save"
                >
                  저장
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          @click="openSignatureList(item)"
        >
          mdi-signature-text
        </v-icon>
      </template>
      <template v-slot:item.report="{ item }">
        <v-icon
          color="blue"
          @click="getPDF(item)"
        >
          mdi-file-pdf-box
        </v-icon>
      </template>
      <template v-slot:item.requestState="{ item }">
        <v-chip
          :color="getColor(item.requestState)"
          x-small
          outlined
          @click="openItemInfo(item)"
        >
          {{ item.requestState }}
          <v-icon
            v-if="item.memo.length > 0"
            color="blue"
            small
          >
            mdi-information
          </v-icon>
        </v-chip>
      </template>
      <template v-slot:item.data-table-expand="{item, isExpanded}">
        댓글 {{ item.commentCount }}
        <v-icon
          @click="handleExpansion(item, isExpanded)"
        >
          {{ isExpanded ? 'mdi-chat-processing' : 'mdi-chat-processing-outline' }}
        </v-icon>
      </template>
      <template v-slot:expanded-item="{ item }">
        <td :colspan="headers.length + 1">
          <comment-list
            :item-id="item.id"
            :item-type="itemType"
            :item-object="item"
          />
        </td>
      </template>
    </v-data-table>

    <!-- 검체정보 입력 다이얼로그 -->
    <v-dialog
      v-model="dialogSpecimen"
      max-width="400px"
    >
      <specimen-item
        :specimen-obj="editSample"
        :cancel-sample-edit="cancelSampleEdit"
        :commit-sample-edit="commitSampleEdit"
      />
    </v-dialog>

    <!-- 테이블 페이지 -->
    <div class="text-center pt-2">
      <v-pagination
        v-model="page"
        :length="pageCount"
      />
      <v-text-field
        v-show="false"
        :value="itemsPerPage"
        label=""
        type="number"
        min="-1"
        max="15"
        @input="itemsPerPage = parseInt($event, 10)"
      />
    </div>

    <!-- 상태 변경 로그용 다이얼로그 -->
    <v-dialog
      v-model="dialogState"
      max-width="300"
    >
      <v-card
        class="mx-auto"
      >
        <v-virtual-scroll
          :items="logStates"
          height="300"
          :item-height="50"
        >
          <template v-slot:default="{ item }">
            <v-list-item>
              <v-list-item-avatar
                left
              >
                <v-icon>mdi-information</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.updateDate }} || {{ item.userName }}
                  <v-spacer />
                  <strong>{{ item.oldState }} -> {{ item.newState }}</strong>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider />
          </template>
        </v-virtual-scroll>
      </v-card>
    </v-dialog>

    <!-- 추가 편집 삭제 버튼 -->
    <v-speed-dial
      v-if="false"
      v-model="fabState.fab"
      :top="fabState.top"
      :right="fabState.right"
      :bottom="fabState.bottom"
      :left="fabState.left"
      :transition="fabState.transition"
    >
      <template v-slot:activator>
        <v-btn
          v-model="fabState.fab"
          color="blue darken-2"
          dark
          fab
          small
        >
          <v-icon v-if="fabState.fab">
            mdi-close
          </v-icon>
          <v-icon v-else>
            mdi-plus
          </v-icon>
        </v-btn>
      </template>
      <v-btn
        v-show="isMultiSelect"
        fab
        dark
        small
        color="green"
        @click="openChangeState"
      >
        <v-icon>mdi-state-machine</v-icon>
      </v-btn>
      <v-btn
        v-show="selectedItem"
        fab
        dark
        small
        color="green"
        @click="editItem"
      >
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
      <v-btn
        v-show="selectedItem"
        fab
        dark
        small
        color="red"
        @click="dialogDelete = true"
      >
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </v-speed-dial>

    <!-- 로딩 -->
    <v-overlay
      :value="loading"
    >
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>

    <!-- 삭제 다이얼로그 -->
    <v-dialog
      v-model="dialogDelete"
      max-width="300"
    >
      <v-card>
        <v-card-title class="text-h5">
          요청 삭제
        </v-card-title>

        <v-card-text>
          지워진 내용은 되돌릴 수 없습니다. 정말 지우시겠습니까?
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="blue darken-1"
            text
            @click="closeDelete"
          >
            취소
          </v-btn>

          <v-spacer />

          <v-btn
            color="blue darken-1"
            text
            @click="deleteItemConfirm"
          >
            확인
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 서명 종류 선택 다이얼로그 -->
    <v-dialog
      v-model="dialogSignature"
      max-width="400px"
    >
      <signature-list
        :request-obj="requestObj"
      />
    </v-dialog>
  </v-container>
</template>

<script>
  import { sync, call } from 'vuex-pathify'
  import DataUtils from '../util/data'
  import FcmAPI from '../api/api-fcm'
  import _ from 'lodash'
  import CommentList from '../components/comment/CommentList.vue'
  import SignatureList from '../components/signature/SignatureList.vue'
  import SpecimenItem from '../components/specimen/SpecimenItem.vue'
  import NumberSpinner from '../components/NumericSpinner.vue'

  export default {
    components: {
      CommentList,
      SignatureList,
      SpecimenItem,
      NumberSpinner,
    },
    data () {
      return {
        itemType: '1',
        options: {},
        expanded: [],
        singleExpand: true,
        fabState: {
          fab: false,
          top: false,
          right: true,
          bottom: true,
          left: false,
          transition: 'slide-y-reverse-transition',
          fabEditable: false,
        },
        headers: [
          { text: '요청일자', align: 'start', width: 110, value: 'requestDate' },
          { text: '진행상태', value: 'requestState' },
          { text: '거래처', value: 'userName' },
          { text: '건수', value: 'samples.length' },
          { text: '서명', value: 'actions' },
          { text: '인수인계서', value: 'report' },
          { text: '', width: 100, value: 'data-table-expand' },

        ],
        states: [
          '수거요청',
          '수거완료',
          '접수완료',
        ],
        // selectedClient: [],
        stateFilter: [],
        itemReadonly: false,
        loading: false,
        DatePickerMenu: false,
        dialog: false,
        dialogDelete: false,
        dialogState: false,
        dialogChangeState: false,
        dialogSignature: false,
        dialogSpecimen: false,
        singleSelect: true,
        selected: [],
        selectedState: null,
        page: 1,
        pageCount: 0,
        itemsPerPage: 10,
        startDatePickerMenu: false,
        endDatePickerMenu: false,
        editedIndex: -1,
        editedItemId: -1,
        editedItemState: '',
        editedItem: {
          id: 0,
          requestDate: '',
          requestState: '',
          memo: '',
          samples: [],
          userName: '',
          spEdta: 0,
          spSerum: 0,
          spUrine: 0,
          spEtc: 0,
          projectName: '',
        },
        initEditedItem: {
          id: -1,
          requestDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
          requestState: '수거요청',
          memo: '',
          samples: [],
          userName: '',
          spEdta: 0,
          spSerum: 0,
          spUrine: 0,
          spEtc: 0,
          projectName: '',
        },
        editedSampleIndex: -1,
        editSample: {
          id: -1,
          initialName: '',
          requestId: -1,
          sampleNum: '',
          labCode: '',
          visit: '',
          spEdta: 0,
          spSerum: 0,
          spUrine: 0,
          spEtc: 0,
          memo: '',
        },
        initSample: {
          id: -1,
          initialName: '',
          requestId: -1,
          sampleNum: '',
          labCode: '',
          visit: '',
          spEdta: 0,
          spSerum: 0,
          spUrine: 0,
          spEtc: 0,
          memo: '',
        },
        requestObj: null,
        // signatureItem: [
        //   { title: '인계자', signNum: '1', signOk: false },
        //   { divider: true, inset: true },
        //   { title: '인수자', signNum: '2', signOk: false },
        //   { divider: true, inset: true },
        //   { title: '인수자2', signNum: '3', signOk: false },
        // ],
      }
    },
    computed: {
      requestLists: sync('request/requestList'),
      logStates: sync('request/logStates'),
      client: sync('account/client'),
      inputStartDate: sync('values/inputStartDate'),
      inputEditDate: sync('values/inputEditDate'),
      selectedClient: sync('values/selectedClient'),
      signatureItem: sync('signature/signatureItem'),
      selectedItem () {
        if (typeof this.selected[0] === 'undefined' || this.selected.length > 1) {
          return false
        } else {
          return true
        }
      },
      filterItems () {
        return this.requestLists.filter((item) => {
          return this.stateFilter.length < 1 || this.stateFilter.includes(item.requestState)
        })
      },
      isMultiSelect () {
        if (this.selected.length > 0) return true
        else return false
      },
      editableInfo () {
        return this.editedItemState !== '접수완료'
      },
      deleteInfo () {
        return (this.editedItemState === '수거요청') && (this.editedItemId > -1)
      },
      isMobile () {
        return DataUtils.isMobile()
      },
    },
    watch: {
      options: {
        handler () {
          this.selected = []
        },
        deep: true,
      },
    },
    created () {
      this.getRequestList()
    },
    methods: {
      fetchLogStates: call('request/fetchLogStates'),
      fetchRequestList: call('request/fetchRequestList'),
      insertRequest: call('request/insertRequest'),
      updateRequest: call('request/updateRequest'),
      deleteRequest: call('request/deleteRequest'),
      GetClientList: call('account/GetClientList'),
      updateRequestState: call('request/updateRequestState'),
      fetchComment: call('comment/fetchComment'),
      getSignature: call('signature/getSignature'),
      handleExpansion (item, state) {
        this.expanded.splice(0, this.expanded.length)

        this.fetchComment({
          itemId: item.id,
          itemType: this.itemType,
        }).then(response => {
          if (state === false) this.expanded.push(item)
        })
      },
      getPDF (item) {
        var fileName = item.userName + '(' + item.requestDate + ')' + '.pdf'
        this.$router.push({
          name: 'PDFViewer',
          params: { fileName: fileName, id: item.id, returnURL: 'components/TestRequestMaster/' },
        })
      },
      getLogStates () {
        this.fetchLogStates(
          this.editedItem.id,
        ).then((response) => {
          this.dialogState = true
        }).catch(e => {
          console.error(e.message)
        })
      },
      getRequestList () {
        this.loading = true
        this.selected = []
        this.expanded = []
        var params = { sdate: this.inputStartDate, edate: this.inputEditDate, allUser: 1, clients: this.selectedClient.join() }

        this.fetchRequestList(params)
          .then((response) => {
            this.loading = false
          })
          .catch(e => {
            console.error(e.message)
            this.loading = false
          })
        this.GetClientList()
          .then().catch()
      },
      getColor (requestState) {
        if (requestState === '수거요청') return 'gray'
        else if (requestState === '수거완료') return 'orange'
        else if (requestState === '접수완료') return 'green'
        else return 'red'
      },
      addSample () {
        this.editedSampleIndex = -1
        this.editSample = _.cloneDeep(this.initSample)

        this.$nextTick(() => {
          this.dialogSpecimen = true
        })
      },
      editedSample (index) {
        this.editedSampleIndex = index
        this.editSample = this.editedItem.samples[index]

        this.$nextTick(() => {
          this.dialogSpecimen = true
        })
      },
      deleteSample (index) {
        this.editedItem.samples.splice(index, 1)
      },
      cancelSampleEdit () {
        this.$nextTick(() => {
          this.editedSampleIndex = -1
          this.dialogSpecimen = false
        })
      },
      commitSampleEdit () {
        if (this.editedSampleIndex < 0) {
          // this.editedItem.samples.unshift(Object.assign({}, this.editSample))
          this.editedItem.samples.push(Object.assign({}, this.editSample))
        } else {
          this.editedItem.samples.splice(this.editedSampleIndex, this.editSample)
        }

        this.$nextTick(() => {
          this.editedSampleIndex = -1
          this.dialogSpecimen = false
        })
      },
      createItem () {
        this.itemReadonly = false
        this.editedIndex = -1
        this.editedItem.samples = []
        this.initEditedItem.samples = []
        this.editedItem = Object.assign({}, this.initEditedItem)
        this.editedItemid = this.editedItem.id
        this.editedItemState = this.editedItem.requestDate

        this.$nextTick(() => {
          this.dialog = true
        })
      },
      editItem () {
        this.itemReadonly = false
        this.editedIndex = this.requestLists.indexOf(this.selected[0])
        // 깊은 복사를 진행
        this.editedItem = _.cloneDeep(this.selected[0])

        this.$nextTick(() => {
          this.dialog = true
        })
      },
      deleteItem () {
        this.deleteRequest(this.editedItem.id)
          .then((response) => {
            FcmAPI.postFCM(this.getFCMMessage(this.editedItem, 'Delete'))
            this.getRequestList()
          })
          .catch(e => console.error(e.message))
        this.dialogDelete = false
        this.dialog = false
      },
      deleteItemConfirm () {
        this.deleteItem()
        this.closeDelete()
      },
      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedIndex = -1
        })
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedIndex = -1
        })
      },
      cancel () {
        this.close()
      },
      getFCMMessage (item, MsgType) {
        var sendTitle = '검체수거 요청'
        var sendBody = ''

        if (MsgType === 'Add') {
          sendBody = ' 추가'
        } else if (MsgType === 'Edit') {
          sendBody = ' 변경'
        } else if (MsgType === 'Delete') {
          sendBody = ' 취소'
        }

        return {
          title: sendTitle + sendBody,
          body: item.requestDate + ' ' + item.userName,
          role: '',
          userId: item.userID,
        }
      },
      save () {
        this.loading = true
        if (this.editedItem.id > -1) {
          // 정보 업데이트
          this.updateRequest({
            requestId: this.editedItem.id,
            params: this.editedItem,
          }).then((response) => {
            if (response.data >= 0) {
              FcmAPI.postFCM(this.getFCMMessage(this.editedItem, 'Edit'))
              this.getRequestList()
            }
          }).catch(e => {
            console.error(e.message)
            this.loading = false
          })
        } else {
          // 정보 추가
          this.insertRequest(this.editedItem)
            .then((response) => {
              if (response.data >= 0) {
                FcmAPI.postFCM(this.getFCMMessage(this.editedItem, 'Add'))
                this.getRequestList()
              }
            }).catch(e => {
              console.error(e.message)
              this.loading = false
            })
        }
        this.close()
      },
      openItemInfo (item) {
        // this.editedItem = Object.assign({}, item)
        this.editedItem = _.cloneDeep(item)
        this.editedItemid = this.editedItem.id
        this.editedItemState = this.editedItem.requestState

        this.$nextTick(() => {
          this.dialog = true
        })
      },
      disablePastDates (val) {
        return val >= new Date(
          Date.now() - new Date().getTimezoneOffset() * 60000,
        )
          .toISOString()
          .substr(0, 10)
      },
      openChangeState () {
        this.dialogChangeState = true
        this.selectedState = null
      },
      changeState () {
        this.loading = true

        for (let i = 0; i < this.selected.length; i++) {
          if (this.selected[i].requestState !== this.selectedState) {
            this.selected[i].requestState = this.selectedState
            this.updateRequestState({
              requestId: this.selected[i].id,
              params: this.selected[i],
            }).then((response) => {
              if (response.data >= 0) {
                FcmAPI.postFCM(this.getFCMMessage(this.selected[i], 'Edit'))
              }
            }).catch(e => {
              console.error(e.message)
            })
          }
        }
        this.loading = false
        this.dialogChangeState = false
        this.selectedState = null
        // this.selected = []
      },
      openSignatureList (item) {
        if (item.requestState !== '접수완료') {
          this.requestObj = item
          this.signatureItem = [
            { title: '인계자', signNum: '1', signOk: false },
            { divider: true, inset: true },
            { title: '인수자', signNum: '2', signOk: false },
            { divider: true, inset: true },
            { title: '인수자2', signNum: '3', signOk: false },
          ]

          this.signatureItem.forEach(element => {
            this.updateSignState(element, item.id)
          })

          this.dialogSignature = true
        }
      },
      async updateSignState (element, id) {
        await this.getSignature({
            requestId: id,
            signNum: element.signNum,
          }).then(response => {
            element.signOk = response.data.signDate != null
          })
      },
    },
  }
</script>

<style lang="scss" scoped>
.date-picker {
  font-size: 11pt;
}
.v-data-table::v-deep th {
  font-size: 11pt !important;
}
.v-data-table::v-deep td {
  font-size: 11pt !important;
}
.v-data-table::v-deep >.v-data-table__wrapper .v-data-table__mobile-row {
  height: initial;
  min-height: 0px;
}
.v-speed-dial {
  position: fixed;
  z-index: 10;
  margin-bottom: 20px;
}
.v-btn--floating {
  position: relative;
}
.container {
  padding: 0px;
}
.v-select {
  padding-left: 10px;
  padding-right: 10px;
}
.v-text-field {
    padding-top: 5px;
}
.my-container {
  padding: 12px;
}
.edit-dialog-td {
  padding-left: 5px;
}
.edit-dialog-tbody {
  padding-top: 10px;
}
</style>
